import React from "react";
import { useChartData } from "./UserChartData";
import { dashboardChartProps } from "../../core/dto/dashboard.dto";
import LineChartWidget from "./LineChartWidget";

const VoiceMailsLineChart = ({ apiEndpoint, startDate, endDate, selectedLocation, onChartLoaded }: dashboardChartProps) => {
    const payload = {
        from_date: startDate ? startDate.toLocaleDateString("en-CA") : null,
        to_date: endDate ? endDate.toLocaleDateString("en-CA") : null,
        location_id: selectedLocation,
        clientTZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const chartData = useChartData(apiEndpoint, payload, onChartLoaded);

    return <LineChartWidget title="Voicemail" chartData={chartData} />;
};

export default VoiceMailsLineChart;
